import React from 'react';
import "../less/index.less";
import DOMPurify from 'utils/sanitize';
import { insuranceIntermediaryInfoCompaniesGovLink } from '../../../../services/urls/urls';
import { getSafeLinkProps } from '../../../../helpers/utils/urlSecurity';

export default function template() {
  const { items, title, onBtnClick, btnText } = this.props;

  return (
    <div className="insurance-intermediary-info">
      <div className="container">
        {(title || onBtnClick) && (
          <div className="insurance-intermediary-info__top">
            {title && <h2 className="insurance-intermediary-info__title">{this.l10n(title)}</h2>}
            {(onBtnClick && btnText) && <button className="insurance-intermediary-info__btn" onClick={onBtnClick}>{this.l10n(btnText)}</button>}
          </div>
        )}
        <div className="insurance-intermediary-info__items">
          {items.map((item, index) => {
            if (item.type === 'companies') {
              return (
                <div key={index} className="insurance-intermediary-info__item item-insurance-intermediary-info">
                  {item.title && <h3 className="item-insurance-intermediary-info__title">{this.l10n(item.title)}</h3>}
                  {item.companies.map((item, index) => (
                    <div className="item-insurance-intermediary-info__company" key={index}>
                      <div className="item-insurance-intermediary-info__subtitle">
                        <b>
                          <span dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(item.subtitle))}}></span>
                          <a {...getSafeLinkProps(item.link)}>{item.link}</a>
                        </b>
                      </div>
                      <div className="item-insurance-intermediary-info__text">
                        {this.l10n('INSURANCE_INTERMEDIARY_INFO_COMMON_TEXT_01')} 
                        <a {...getSafeLinkProps(item.link)}>{item.link}</a>
                        <br/>
                        {this.l10n('INSURANCE_INTERMEDIARY_INFO_COMMON_TEXT_02')} 
                        <a {...getSafeLinkProps(insuranceIntermediaryInfoCompaniesGovLink)}>{this.l10n('INSURANCE_INTERMEDIARY_INFO_COMMON_TEXT_03')}</a>
                      </div>
                    </div>
                  ))}
                </div>
              );
            }
            return (
              <div key={index} className="insurance-intermediary-info__item item-insurance-intermediary-info">
                {item.title && <h3 className="item-insurance-intermediary-info__title">{this.l10n(item.title)}</h3>}
                <div className="item-insurance-intermediary-info__text" dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(this.l10n(item.text), {
                    ADD_ATTR: ['target', 'rel']
                  })
                }}></div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
